function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Top3Types = exports.Top3Container = exports.Top3 = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _Heading = require("../Heading");
var _Button = require("../Button");
var Icons = _interopRequireWildcard(require("../Icons"));
var _Select = require("../Select");
var _utils = require("../../utils");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _SvgImage = require("../SvgImage");
var _styles2 = require("../../styles");
var _NoTranslate = require("../NoTranslate");
var _ActivityIndicator = require("../ActivityIndicator");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "style"],
  _excluded2 = ["title", "subTitle", "type", "sort", "items", "actionLabel", "actionLink", "showConfetti", "valueSuffix", "emptyMessage", "isLoading", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Top3Types = exports.Top3Types = function (Top3Types) {
  Top3Types[Top3Types["list"] = 0] = "list";
  Top3Types[Top3Types["podium"] = 1] = "podium";
  return Top3Types;
}({});
var Top3Container = exports.Top3Container = (0, _react.memo)(function (_ref) {
  var children = _ref.children,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  return (0, _jsxRuntime.jsx)(_reactNative.View, Object.assign({
    style: [styles.container, style]
  }, props, {
    children: _react.Children.map(children, function (child) {
      if ((0, _react.isValidElement)(child)) {
        return (0, _jsxRuntime.jsx)(_reactNative.View, {
          style: styles.containerItem,
          children: child
        });
      }
      return child;
    })
  }));
});
var NameContainer = (0, _react.memo)(function (_ref2) {
  var _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? '' : _ref2$name,
    _ref2$translateName = _ref2.translateName,
    translateName = _ref2$translateName === void 0 ? true : _ref2$translateName;
  if (translateName === false) {
    return (0, _jsxRuntime.jsx)(_NoTranslate.NoTranslate, {
      children: name
    });
  }
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: name
  });
});
var Top3 = exports.Top3 = (0, _react.memo)(function (_ref3) {
  var title = _ref3.title,
    subTitle = _ref3.subTitle,
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? Top3Types.list : _ref3$type,
    sort = _ref3.sort,
    items = _ref3.items,
    actionLabel = _ref3.actionLabel,
    actionLink = _ref3.actionLink,
    showConfetti = _ref3.showConfetti,
    valueSuffix = _ref3.valueSuffix,
    emptyMessage = _ref3.emptyMessage,
    isLoading = _ref3.isLoading,
    style = _ref3.style,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles2 = (0, _styles.useStyles)(),
    styles = _useStyles2.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  var _useState = (0, _react.useState)((0, _utils.GenerateId)()),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    id = _useState2[0];
  var hasSort = !!sort && !!sort.items && sort.items.length > 0;
  var hasItems = !!items && items.length > 0;
  var hasAction = !!actionLabel && !!actionLink;
  var _itemsLength = hasItems ? items.length : 0;
  var _breakPoint = bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal]);
  var _changePodiumOrder = !_breakPoint && hasItems && items.length > 2;
  var _firstIndex = _changePodiumOrder ? 1 : 0;
  var getStepHeight = function getStepHeight(index, value) {
    var _items$;
    if (_reactNative.Platform.OS === 'web' && !!value && !!(items != null && (_items$ = items[0]) != null && _items$.value)) {
      var step = Math.abs(value) / Math.abs(items[0].value);
      return {
        height: "calc(".concat(step, " * ").concat((0, _styles2.getREM)(10)).concat(index !== 0 ? ' - 1rem' : '', ")")
      };
    }
    return undefined;
  };
  if (typeof items === 'undefined' && !emptyMessage) {
    return null;
  }
  return (0, _jsxRuntime.jsxs)(_reactNative.View, Object.assign({
    style: [styles.box, style],
    testID: "Top3"
  }, props, {
    children: [(0, _jsxRuntime.jsxs)(_reactNative.View, {
      children: [showConfetti && (0, _jsxRuntime.jsxs)(_reactNative.View, {
        style: styles.confettiContainer,
        testID: "Top3Confetti",
        children: [(0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
          image: require("./images/confetti-left.svg"),
          style: styles.confettiLeft
        }), (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
          image: require("./images/confetti-right.svg"),
          style: styles.confettiRight
        })]
      }), (0, _jsxRuntime.jsx)(_Heading.Heading, {
        level: 3,
        style: styles.title,
        children: title
      }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: styles.subTitle,
        children: subTitle
      })]
    }), !hasItems && !isLoading && emptyMessage && (0, _jsxRuntime.jsx)(_reactNative.Text, {
      style: styles.emptyMessage,
      children: emptyMessage
    }), hasSort && (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: styles.sort,
      testID: "Top3Sort",
      children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: styles.sortLabel,
        children: sort.label
      }), (0, _jsxRuntime.jsx)(_Select.Select, {
        items: sort.items,
        selectedId: sort.selectedId,
        onSelect: sort.onSelect,
        style: styles.sortSelect,
        type: _Select.SelectType.outline,
        label: sort.label,
        hideLabel: true
      })]
    }), isLoading && (0, _jsxRuntime.jsx)(_ActivityIndicator.ActivityIndicator, {
      style: styles.activityIndicator
    }), !isLoading && type === Top3Types.list && hasItems && (0, _jsxRuntime.jsx)(_reactNative.View, {
      style: styles.tileContainer,
      testID: "Top3List",
      children: items.map(function (item, index) {
        var _items$2;
        var step = 0;
        if (item.value && items != null && (_items$2 = items[0]) != null && _items$2.value) {
          step = Math.abs(item.value) / Math.abs(items[0].value);
        }
        var tileWidth = {};
        if (_reactNative.Platform.OS === 'web' && typeof item.value !== 'undefined' && bp.not([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m])) {
          tileWidth = {
            width: "calc(".concat(step, " * 100%").concat(index !== 0 ? ' - 1rem' : '', ")")
          };
        }
        return (0, _jsxRuntime.jsxs)(_reactNative.View, {
          style: [styles.tile, tileWidth],
          children: [!!item.url && (0, _jsxRuntime.jsx)(_Button.Button, {
            type: _Button.ButtonType.blank,
            href: item.url,
            label: item.name,
            containerStyle: styles.tileLinkContainer,
            textStyle: styles.tileLink,
            hideLabel: true
          }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
            children: [index === 0 && (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
              image: require("../../images/Crown.svg"),
              style: styles.tileImage
            }), index === 1 && (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
              image: require("../../images/Medal2.svg"),
              style: styles.tileImage
            }), index === 2 && (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
              image: require("../../images/Medal3.svg"),
              style: styles.tileImage
            })]
          }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
            style: styles.tileContent,
            children: [!!item.name && (0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: styles.tileLabel,
              children: (0, _jsxRuntime.jsx)(NameContainer, {
                name: item.name,
                translateName: item.translateName
              })
            }), typeof item.value !== 'undefined' && (0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: styles.tileValue,
              children: "".concat(item.value).concat(valueSuffix ? " ".concat(valueSuffix) : "")
            }), !!item.url && (0, _jsxRuntime.jsx)(_Button.Button, {
              isFake: true,
              size: _Button.ButtonSize.small,
              label: t('top3:buttonLabel')
            })]
          })]
        }, "top3-".concat(id, "-item-").concat(index));
      })
    }), !isLoading && type === Top3Types.podium && hasItems && (0, _jsxRuntime.jsx)(_reactNative.View, {
      style: styles.podium,
      testID: "Top3Podium",
      children: (_changePodiumOrder ? [items[1], items[0], items[2]] : items).map(function (item, index) {
        if (_breakPoint && !(item != null && item.name)) return null;
        return (0, _jsxRuntime.jsxs)(_reactNative.View, {
          style: styles.podiumItem,
          children: [(item == null ? void 0 : item.name) && (0, _jsxRuntime.jsxs)(_reactNative.View, {
            style: [styles.podiumItemImage, index === _firstIndex && styles.podiumItemImage_first],
            children: [(0, _jsxRuntime.jsx)(_reactNative.View, {
              style: [styles.podiumItemLogoContainer, index === _firstIndex && styles.podiumItemLogoContainer_first],
              children: (item == null ? void 0 : item.image) && (0, _jsxRuntime.jsx)(_reactNative.Image, {
                source: {
                  uri: item.image
                },
                accessibilityLabel: "".concat(item == null ? void 0 : item.name, " logo"),
                style: styles.podiumItemLogo
              })
            }), (!_changePodiumOrder && index === 0 || _changePodiumOrder && index === 1) && (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
              image: require("../../images/Crown.svg"),
              style: styles.podiumItemImageCrown
            }), (!_changePodiumOrder && index === 1 || _changePodiumOrder && index === 0) && (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
              image: require("../../images/Medal2.svg"),
              style: styles.podiumItemImageMedal
            }), index === 2 && (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
              image: require("../../images/Medal3.svg"),
              style: styles.podiumItemImageMedal
            })]
          }), (item == null ? void 0 : item.name) && (0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: styles.podiumItemName,
            children: (0, _jsxRuntime.jsx)(NameContainer, {
              name: item.name,
              translateName: false
            })
          }), (0, _jsxRuntime.jsx)(_reactNative.View, {
            style: [styles.podiumItemStep, _itemsLength < 3 ? [styles.podiumItemStep_right].concat() : [index === 0 && styles.podiumItemStep_left, index === 2 && styles.podiumItemStep_right].concat(), index === _firstIndex && styles.podiumItemStep_first, getStepHeight(0, item == null ? void 0 : item.value)]
          }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: styles.podiumItemValue,
            children: item != null && item.name ? "".concat(item == null ? void 0 : item.value).concat(valueSuffix ? " ".concat(valueSuffix) : "") : '-'
          })]
        }, index);
      })
    }), hasAction && (0, _jsxRuntime.jsxs)(_Button.Button, {
      type: _Button.ButtonType.link,
      href: actionLink,
      containerStyle: styles.linkContainer,
      children: [actionLabel, (0, _jsxRuntime.jsx)(Icons.RightArrow, {
        style: styles.linkIcon
      })]
    })]
  }));
});